import { clientFor, type PageQuery, type PageResult, type Status } from '@yc/api-client'

const api = clientFor('/wms/api')

export interface Sku {
  id: number
  tenant_id: number
  code: string
  name: string
  barcode: string
  spec: string
  unit: string
  weight_g: number
  volume_cm3: number
  batch_managed: boolean
  shelf_life_days: number
  status: Status
  created_at: string
  updated_at: string
}

export interface SkuInput {
  code: string
  name: string
  barcode: string
  spec: string
  unit: string
  weight_g: number
  volume_cm3: number
  batch_managed: boolean
  shelf_life_days: number
  status: Status
}

export interface SkuQuery extends PageQuery {
  keyword?: string
  status?: string
}

/** 与后端 services/wms/internal/sku 的字典保持一致，改一边必须改另一边 */
export const STATUS_LABELS: Record<Status, string> = { active: '启用', disabled: '停用' }

export const listSkus = (q: SkuQuery): Promise<PageResult<Sku>> =>
  api.get<PageResult<Sku>>('/skus', { ...q })

export const createSku = (input: SkuInput): Promise<Sku> => api.post<Sku>('/skus', input)

export const updateSku = (id: number, input: SkuInput): Promise<Sku> =>
  api.put<Sku>(`/skus/${id}`, input)

export const deleteSku = (id: number): Promise<void> => api.del<void>(`/skus/${id}`)
